import { render, staticRenderFns } from "./ReceiptEditAddMedV5Covit.vue?vue&type=template&id=80c79652&"
import script from "./ReceiptEditAddMedV5Covit.vue?vue&type=script&lang=ts&"
export * from "./ReceiptEditAddMedV5Covit.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptEditAddMedV5Covit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
